import React from 'react'
import { FormControlLabel, Checkbox as MUICheckbox } from '@material-ui/core'
import PropTypes from 'prop-types'

const Checkbox = ({ id, label, checked, onChange }) => (
  <FormControlLabel
    control={
      <MUICheckbox
        id={id}
        checked={checked}
        onChange={onChange}
        inputProps={{ 'aria-label': label }}
      />
    }
    label={label}
  />
)

Checkbox.defaultProps = {
  checked: false,
}

Checkbox.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

export default Checkbox
